import { supabase } from '../supabaseClient';

// --- GAME HISTORY ---

export const saveGame = async ({ players, finalScores, winners, ratingChanges, gameLog }) => {
  const { data, error } = await supabase
    .from('games')
    .insert({
      players,
      final_scores: finalScores,
      winners,
      num_players: players.length,
      rating_changes: ratingChanges || null,
      game_log: gameLog || null,
    })
    .select()
    .single();

  if (error) throw error;
  return data;
};

/**
 * Fetches the most recent games that a player participated in.
 * Returns games that have a game_log (for replay), ordered newest-first.
 */
export const getRecentGames = async (username, limit = 10) => {
  const { data, error } = await supabase
    .from('games')
    .select('id, players, final_scores, winners, num_players, game_log, created_at')
    .contains('players', [username])
    .not('game_log', 'is', null)
    .order('created_at', { ascending: false })
    .limit(limit);

  if (error) throw error;
  return data || [];
};

// --- ELO RATING ---

/**
 * Update ELO ratings for a batch of players after a game.
 * update_player_ratings RPC confirmed deployed (functions.sql §2).
 * ratingUpdates format: [{ username, oldRating, newRating, change, gameId }, ...]
 */
export const updatePlayerRatings = async (ratingUpdates) => {
  const payload = ratingUpdates.map(u => ({
    username: u.username,
    newRating: u.newRating,
    oldRating: u.oldRating,
    change: u.change,
    gameId: u.gameId,
    score: u.score ?? 0,
  }));

  const { error } = await supabase.rpc('update_player_ratings', { p_updates: payload });
  if (error) throw error;
};

// --- STATS ---

export const updateStats = async (winners, humanPlayers, finalScores) => {
  const { error } = await supabase.rpc('update_all_stats', {
    p_usernames: humanPlayers,
    p_winners: winners,
    p_scores: finalScores,
  });

  if (error) {
    console.error('Could not update stats:', error.message);
    throw error;
  }
};
